"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfNotificationSubscriptionUpdateDto = instanceOfNotificationSubscriptionUpdateDto;
exports.NotificationSubscriptionUpdateDtoFromJSON = NotificationSubscriptionUpdateDtoFromJSON;
exports.NotificationSubscriptionUpdateDtoFromJSONTyped = NotificationSubscriptionUpdateDtoFromJSONTyped;
exports.NotificationSubscriptionUpdateDtoToJSON = NotificationSubscriptionUpdateDtoToJSON;
exports.NotificationSubscriptionUpdateDtoToJSONTyped = NotificationSubscriptionUpdateDtoToJSONTyped;
const TopicSubscriptionUpdateDto_1 = require("./TopicSubscriptionUpdateDto");
/**
 * Check if a given object implements the NotificationSubscriptionUpdateDto interface.
 */
function instanceOfNotificationSubscriptionUpdateDto(value) {
    if (!('topics' in value) || value['topics'] === undefined)
        return false;
    return true;
}
function NotificationSubscriptionUpdateDtoFromJSON(json) {
    return NotificationSubscriptionUpdateDtoFromJSONTyped(json, false);
}
function NotificationSubscriptionUpdateDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'topics': (json['topics'].map(TopicSubscriptionUpdateDto_1.TopicSubscriptionUpdateDtoFromJSON)),
    };
}
function NotificationSubscriptionUpdateDtoToJSON(json) {
    return NotificationSubscriptionUpdateDtoToJSONTyped(json, false);
}
function NotificationSubscriptionUpdateDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'topics': (value['topics'].map(TopicSubscriptionUpdateDto_1.TopicSubscriptionUpdateDtoToJSON)),
    };
}
//# sourceMappingURL=NotificationSubscriptionUpdateDto.js.map